const _global = (window /* browser */ || global) /* node */ as any;

import { CRMMapClass } from "../../../src/js/crmmap/CRMMapClass";
import { getGeocodeFromAddress } from "../../../src/js/home/geocoder";

declare var CRMMap: CRMMapClass;
//----------Hacks ;)

export class Guid {
  static newGuid() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
      var r = Math.random() * 16 | 0,
        v = c == 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  }
}


export let distanceBetweenPoints = (p1: any, p2: any) => {
  return Math.abs(Math.sqrt(getDistanceY(p1, p2) + getDistanceX(p1, p2)));
};

export let getDistanceY = (p1: any, p2: any) => {
  return (
    <number>(Number(p1.lat) - Number(p2.lat)) *
    (Number(p1.lat) - Number(p2.lat))
  );
};

export let getDistanceX = (p1: any, p2: any): number => {
  return (
    <number>(Number(p1.lng) - Number(p2.lng)) *
    (Number(p1.lng) - Number(p2.lng))
  );
};

export let geosync = (a: string): Promise<any> => {
  return new Promise<any>((r) => {
    if (!a) {
      return r(null);
    }

    console.log("geosync", a, typeof a);
    return getGeocodeFromAddress(a)
      .catch((error) => {
        console.log("Failed to get Locaiton", error);
        CRMMap.showstatus(error);
      })
      .then((addressIn) => {
        console.log("getGeocodeFromAddress", addressIn);
        CRMMap.showstatus(a);
        

           return (addressIn?addressIn.geometry.location:'') 
      });
  });
};

export let popCloest=(allstops: any[], stop: any) => {
  for (let index = 0; index < allstops.length; index++) {
    const element = allstops[index];
    let d = distanceBetweenPoints(stop.geo, element.geo);
    allstops[index].distance = d;
  }

  allstops.sort((a, b) => b.distance - a.distance);
  var r = allstops.pop();
  return r;
}




export let  delay = (ms: number) => {
  return new Promise( resolve => setTimeout(resolve, ms) );
}



export let fadeOut = (e: HTMLElement) => {
  return new Promise((r) => {
    var opacity: number = e.style.opacity ? parseFloat(e.style.opacity) : 1;
    if (opacity > 0) {
      opacity -= 0.2;
      e.style.opacity = Math.max(opacity,0).toString();
      return setTimeout(() => {
        return fadeOut(e).then(r);
      }, 100);
    }
    return r(e);
  });
};

export let waitforid = (
  id: string,
  maxtrys: number = 10,
  count: number = 0
): Promise<Element> => {
  return new Promise((res, rej) => {
    count++;
    if (id.length <= 0) {
      return rej("Nothing to wait for");
    }
    let d = <Element>document.querySelector(id);
    if (d) {
      return res(d);
    }
    if (count > maxtrys) {
      return rej("Waited for to long for id, " + id);
    }

    setTimeout(() => {
      return waitforid(id, maxtrys, count);
    }, 100);
  });
};

export let _selected = (td: any) => {
  //TODO remove jQuery
  var ids = jQuery.map(td.rows(".selected"), function (item) {
    return item;
  });
  return ids.length > 0 ? ids[0] : false;
};

export let _forEach = (array: any, callback) => {
  for (var i = 0; i < array.length; i++) {
    callback(i, array[i]);
  }
};

export let _getstatus = (Statuses: any[], id: string) => {
  for (let index = 0; index < Statuses.length; index++) {
    const element = <any>Statuses[index];
    if (element[0] == id) {
      return element;
    }
  }
  return false;
};

export const iconfix = () => {
  var tempa = document.querySelectorAll(".glyphicon.icon-arrow-right");
  _forEach(tempa, (index, div) => {
    div.classList.remove("icon-arrow-right");
    div.classList.add("glyphicon-chevron-right");
  });
  var tempb = document.querySelectorAll(".glyphicon.icon-arrow-left");
  _forEach(tempb, (index, div) => {
    div.classList.remove("icon-arrow-left");
    div.classList.add("glyphicon-chevron-left");
  });
};

if (!_global.iconfix) {
  //Let everyone use it
  _global.iconfix = iconfix;
}




import * as crypto from "crypto";
export const md5 = (contents: string) =>
  crypto.createHash("md5").update(contents).digest("hex");

  export function time_ago(time) {
  switch (typeof time) {
    case "number":
      break;
    case "string":
      time = +new Date(time);
      break;
    case "object":
      if (time.constructor === Date) time = time.getTime();
      break;
    default:
      time = +new Date();
  }
  var time_formats = [
    [60, "seconds", 1], // 60
    [120, "1 minute ago", "1 minute from now"], // 60*2
    [3600, "minutes", 60], // 60*60, 60
    [7200, "1 hour ago", "1 hour from now"], // 60*60*2
    [86400, "hours", 3600], // 60*60*24, 60*60
    [172800, "Yesterday", "Tomorrow"], // 60*60*24*2
    [604800, "days", 86400], // 60*60*24*7, 60*60*24
    [1209600, "Last week", "Next week"], // 60*60*24*7*4*2
    [2419200, "weeks", 604800], // 60*60*24*7*4, 60*60*24*7
    [4838400, "Last month", "Next month"], // 60*60*24*7*4*2
    [29030400, "months", 2419200], // 60*60*24*7*4*12, 60*60*24*7*4
    [58060800, "Last year", "Next year"], // 60*60*24*7*4*12*2
    [2903040000, "years", 29030400], // 60*60*24*7*4*12*100, 60*60*24*7*4*12
    [5806080000, "Last century", "Next century"], // 60*60*24*7*4*12*100*2
    [58060800000, "centuries", 2903040000], // 60*60*24*7*4*12*100*20, 60*60*24*7*4*12*100
  ];
  var seconds = (+new Date() - time) / 1000,
    token = "ago",
    list_choice = 1;

  if (seconds == 0) {
    return "Just now";
  }
  if (seconds < 0) {
    seconds = Math.abs(seconds);
    token = "from now";
    list_choice = 2;
  }
  var i = 0,
    format;
  while ((format = time_formats[i++]))
    if (seconds < format[0]) {
      if (typeof format[2] == "string") return format[list_choice];
      else
        return Math.floor(seconds / format[2]) + " " + format[1] + " " + token;
    }
  return time;
}

export function getCookie(cname) {
  var name = cname + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(";");
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}



export function until(conditionFunction: () => boolean):Promise<any> {
  const poll = (resolve) => {
    if(conditionFunction()) resolve();
    else setTimeout(_ => poll(resolve), 400);
  }
  return new Promise(poll);
}
